export const mapTranslatedOptions = ({ options, t }) =>
  options.map((option) => ({
    value: option.value,
    label: option.labelKey ? t(option.labelKey) : option.label,
  }));
